<template>
  <div class="no-more">没有更多了</div>
</template>

<script>
	export default {
		name: 'w-no-more',
		data () {
			return {}
		},
		mounted () {
		},
		computed: {},
		watch: {},
		components: {},
		methods: {}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/variable';
  .no-more {
    width: 100%;
    text-align: center;
    font-size: 12px;
    color: $color-light-gray;
    margin: 16px 0;
  }
</style>
